module.exports = __webpack_public_path__ + "static/img/paternity-mother.558472d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-paternity-test/paternity-mother.jpg
// module id = bUw+
// module chunks = 0